import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{


  constructor(private angularFireAuth: AngularFireAuth, private router: Router) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.angularFireAuth.authState.pipe(
      map(user => {
        if (user) {
          // Si el usuario está autenticado, permitir el acceso
          return true;
        } else {
          // Si el usuario no está autenticado, redirigir a la página de inicio de sesión
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }

}
